import { useSyncExternalStore } from "react";

function subscribe() {
  return () => {};
}

export default function useBrowser() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
